// Please put date in YYYY-MM-DD format
export const sosPhotos = [
    {
        name: "SOS 2018 Flip-Flop",
        desc: "Exposure of Khandy's Flip-Flop.",
        date: "2018-06-17",
    	imgname: "sos-2018-0.png",
    	credits: "Khandy",
    },
    {
        name: "SOS 2018 Flip-Flop",
        desc: "Crew picture of Flip-Flop's debut!",
        date: "2018-06-17",
    	imgname: "sos-2018-1.png",
    	credits: "Khandy",
    },
    {
        name: "SOS 2018 Flow",
        desc: "Crew picture of SOS Flow 2018!",
        date: "2018-06-17",
    	imgname: "sos-2018-2.png",
    	credits: "Khandy",
    },
    {
        name: "SOS 2019 Park Practice",
        desc: "Max teaching the young padawan Edward.",
        date: "2019-06-01",
    	imgname: "sos-2019-0.png",
    	credits: "Khandy",
    },
    {
        name: "SOS 2019 Park Practice",
        desc: "From left to right: confused Alvin, chill Sam, amused Evan.",
        date: "2019-06-01",
    	imgname: "sos-2019-1.png",
    	credits: "Khandy",
    },
    {
        name: "SOS 2019 Park Practice",
        desc: "From left to right: falling Steven, stringing Steve, Tiffany squared.",
        date: "2019-06-01",
    	imgname: "sos-2019-2.png",
    	credits: "Khandy",
    },
    {
        name: "SOS 2019 Park Practice",
        desc: "Raymond and wand feat. Eddie",
        date: "2019-06-01",
    	imgname: "sos-2019-3.png",
    	credits: "Khandy",
    },
    {
        name: "SOS 2019 Park Practice",
        desc: "Alvin stringing.",
        date: "2019-06-01",
    	imgname: "sos-2019-4.png",
    	credits: "Khandy",
    },
    {
        name: "SOS 2019 Park Practice",
        desc: "Sam teaching her flip flop piece.",
        date: "2019-06-01",
    	imgname: "sos-2019-5.png",
    	credits: "Khandy",
    },
    {
        name: "SOS 2019 Park Practice",
        desc: "Vivian teaching her flip flop piece.",
        date: "2019-06-01",
    	imgname: "sos-2019-6.png",
    	credits: "Khandy",
    },
    {
        name: "SOS 2019 Park Practice",
        desc: "Chloe balancing a staff on her hand.",
        date: "2019-06-01",
    	imgname: "sos-2019-7.png",
    	credits: "Khandy",
    },
    {
        name: "SOS 2019 Crew Pic",
        desc: "Big crew picture of SOS 2019 gang.",
        date: "2019-06-09",
    	imgname: "sos-2019-8.png",
    	credits: "Khandy",
    },
    {
        name: "SOS 2020 Postcard",
        desc: "Postcard for our 2020 virtual performance. Designed by Jasmine Xiao.",
        date: "2020-06-24",
    	imgname: "sos-2020-0.png",
    	credits: "Jasmine",
    },


]
